var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.457%",
    y1: "100%",
    x2: "14.543%",
    y2: "0%",
    id: "Success_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B99",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BADBC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0a2 2 0 012 2v15a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h12zM5.611 9H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5H5.61a.5.5 0 00.5-.5V9.5a.5.5 0 00-.5-.5zm3.667-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h6.222a.5.5 0 00.5-.5V6.8a.5.5 0 00-.5-.5zm3.666-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h9.888a.5.5 0 00.5-.5V4.1a.5.5 0 00-.5-.5z",
    fill: "url(#Success_svg__[object_Object]a)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 16,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.667a5.333 5.333 0 015.329 5.113l.004.22a5.333 5.333 0 01-5.113 5.329l-.22.004a5.333 5.333 0 010-10.666zm2.195 2.798a.454.454 0 00-.053.059l-3.077 4.086-1.164-1.5a.504.504 0 00-.731-.061.438.438 0 00-.041.593l1.344 1.739a.759.759 0 001.005.165c.07-.045.13-.101.179-.165l3.257-4.326a.438.438 0 00-.04-.593.507.507 0 00-.68.003z",
    fill: "#1DC463"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default ForwardRef;